export const initializeImagePicker = () => {
  const pickerForm = document.querySelector('.picker-form');
  if(pickerForm) {
    imagePicker(pickerForm);
  }
}

const imagePicker = function (container) {
  if(container.tagName.toLowerCase() != 'form') {
    throw 'This only works for form elements'
  }

  container.addEventListener('change', function (event) {
    var element = event.currentTarget;
    var options = $('.selectable-option', element);
    var checked = $('.selectable-option:checked', element);
    var button = $('input:submit', element);
    button.attr('disabled', checked.length <= 0);

    // update counter of selected images
    var counter = $('.picker-selected', element);
    if (counter) {
      counter.text(checked.length);
    }

    // if we are dealing with radio buttons we just skip the last validation of the limit
    // of items selected
    var option = options.get(0);
    if (option && option.type == 'radio') {
      return;
    }

    // now we need to check the limit of images and if we are reaching
    // that value
    var limit = element.dataset.limit;
    if (limit) {
      limit = parseInt(limit);
      var items = $('.selectable-option:not(:checked)', element);
      if (checked.length === limit) {
        items.attr('disabled', true);
      } else if (checked.length < limit) {
        items.attr('disabled', false);
      }
    }
  });

  container.addEventListener('submit', function (event) {
    var form = event.currentTarget;
    var option = $('.selectable-option:checked', form).get(0);
    // if we are dealing with radio buttons, we will add a hidden field for the filename
    // the field should be supplied through a `data-` attribute
    if (option && option.type == 'radio') {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'filename';
      input.value = option.dataset.filename;
      form.appendChild(input);
    }
  });
};